import { VOMedia, VOMediaType } from "../model/DataStructure.js";
import { MediaContent, MediaContentOptions } from "./MediaContent.js";
import { VideoControl } from "./VideoControl.js";

export interface MediaVideoOptions extends MediaContentOptions {

}

export class MediaVideo extends MediaContent<MediaVideoOptions>{

    public readonly type: VOMediaType = "video";

    private _content: HTMLVideoElement;
    private _videoControl: VideoControl;

    constructor(options: MediaVideoOptions) {
        super(options);

        this._element.classList.add("media-video");

        this._content = document.createElement("video");
        this._content.className = "media-content__content media-video__content";
        this._body.appendChild(this._content);

        this._videoControl = new VideoControl({
            container: this._control,
            video: this._content,
            visible: true
        });

        this.onHide.add(() => {
            this._content.pause();
        })

        this._content.addEventListener("playing", () => {
            this.onReady.dispatch();
        });
    }

    protected getAspectRatio(data: VOMedia): number | null {
        if (!data.video) {
            return null;
        }
        return data.video.width / data.video.height;
    }

    public load(data: VOMedia): void {
        this.onLoad.dispatch();

        this._content.style.aspectRatio = `${data.video.width} / ${data.video.height}`;
        this._content.src = data.video.url;
        this._content.play();
        this._videoControl.update();

        this.caption = data.caption || "";
    }
}